<!--  -->
<template>
  <div class="wrapper box box_v" ref="wrapper">
    <div class="header-wrapper box">
      <div class="left" @click="goback">
        <div class="iconfont icon-fanhui2" style="font-size:35px"></div>
      </div>
      <div class="header">信息采集</div>
      <div class="addManager">
        <Button class="btn-dc" type="primary" style="margin-right: 20px" @click="changeEdit" :loading="isSave">{{isEditable?'保存':'编辑'}}</Button>
      </div>
    </div>
    <div class="content box_f1" ref="contentbox">
      <div class="contenttitle">信息采集设置</div>
      <div class="contentbox box" :style="{ height: height+'px'}">
        <div class="contentop">选项</div>
        <div class="options box_f1" v-if="isEditable">
          <div v-for="(item,index) in options" :key="item.index" class="option_item_edit">
            <div>选项{{$util.number2Chinese(index+1)}}</div>
            <div class="box">
              <div class="input-wrapper box_v edit1">
                                <textarea
                                  placeholder="请输入选项标题"
                                  v-model="item.title"
                                  class="edit-title box_f1"
                                  @input="titleinput"
                                  maxlength="32"
                                >
                                </textarea>
                <div class="title-number">{{item.title.length}}/32</div>
              </div>
              <div class="iconfont icon-shanchu delete" @click="deleteClick(index,'all')"></div>
            </div>
            <div class="box" v-if="item.contentShow">
              <div class="input-wrapper box_v edit2">
                                <textarea
                                  placeholder="请输入选项描述"
                                  v-model="item.content"
                                  class="edit-title box_f1"
                                  @input="titleinput"
                                  maxlength="64"
                                >
                                </textarea>
                <div class="title-number">{{item.content.length}}/64</div>
              </div>
              <div class="iconfont icon-shanchu delete" @click="deleteClick(index,'content')"></div>
            </div>
            <div v-else class="box add2" @click="addDetail(index,'contentShow')"><div class="iconfont icon-tianjia"></div>添加描述</div>
            <div class="box" v-if="item.userShow" style="width:567px">
              <Checkbox v-model="item.userCheck" style="width:70px;color:#666" @on-change="selectChange">必填</Checkbox>
              <Input placeholder="请输入提示标题" v-model="item.userTitle"/>
              <div class="iconfont icon-shanchu delete" @click="deleteClick(index,'userwrite')"></div>
            </div>
            <div class="box add2" v-else @click="addDetail(index,'userShow')"><div class="iconfont icon-tianjia"></div>用户填写</div>
          </div>
          <div class="box add2 add" @click="addItem"><div class="iconfont icon-tianjia"></div>添加选项</div>
          <Modal
            v-model="deleteModal"
            title="删除"
            @on-ok="ok"
            @on-cancel="cancel">
            <p>确定要删除这个选项吗？</p>
          </Modal>
        </div>
        <div class="options box_f1" v-else>
          <div v-for="(item,index) in options" :key="item.id" class="option_item">
            <div>选项{{$util.number2Chinese(index+1)}}</div>
            <div>{{item.title}}</div>
            <div>{{item.content}}</div>
            <div class="box">
              <div>用户填写：</div>
              <div class="color">{{item.userTitle}}</div>
              <div class="color" v-if="item.userCheck">*</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';

  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      //这里存放数据
      return {
        height:0,
        isEditable:false,
        isSave:false,
        deleteModal:false,
        deleteIndex:0,
        options:[
          //     {
          //     id:1,
          //     title:'第一序列',
          //     content:'第一序列描述',
          //     contentShow:true,
          //     userShow:true,
          //     userCheck:true,
          //     userTitle:'',
          //     userfill:[]
          // },{
          //     id:2,
          //     title:'',
          //     content:'',
          //     contentShow:false,
          //     userShow:false,
          //     userCheck:false,
          //     userTitle:'',
          //     userfill:['用户填写','用户第二个'],
          // }
        ]
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      userfill2String(val){
        return val.join('*,')
      },
      goback() {
        this.$router.push({ name: "carManage", query: { state: 1 } });
      },
      changeEdit(){
        if(this.isEditable){
          this.save()
        }else{
          this.isEditable=true
        }

      },
      titleinput(e) {
        console.log(e)
        console.log(this.options)
        // this.editTitle = e.target.value;
        // this.sendItems[this.changeIndex].title = e.target.value;
      },
      addDetail(index,val){
        this.options[index][val] = true
      },
      selectChange(e){
        console.log(e)
        console.log(this.options)
      },
      deleteClick(index,val){
        switch(val){
          case 'all':
            this.deleteModal = true;
            this.deleteIndex = index;
            break;
          case 'content':
            this.options[index].content = '';
            this.options[index].contentShow = false;
            break;
          case 'userwrite':
            this.options[index].userTitle = '';
            this.options[index].userShow = false;
            this.options[index].userCheck = false;
            break;
        }
      },
      ok(){
        //删除选项
        let index = this.deleteIndex
        let deleteId = this.options[index].id
        if(this.options[index].id != -1){
          let url = this.urlobj.deleteParkingOption(deleteId);
          this.$delete(url, {}).then(res => {
            if(res.isSucceed){
              this.$Message.success('删除成功')
              this.options.splice(this.deleteIndex,1)
            }
          }).catch(e=>{
          })
        }else{
          this.$Message.success('删除成功')
          this.options.splice(index,1)
        }


      },
      cancel(){},
      addItem(){
        //添加选项
        this.options.push({
          index:this.options.length-1,
          id:-1,
          title:'',
          content:'',
          contentShow:false,
          userShow:false,
          userCheck:false,
          userTitle:'',
        })
      },
      save(){
        let canSave = this.options.every((item,index)=>{
          if(!item.title){
            this.$Message.info("请输入第"+(index+1)+"个选项标题");
            return false
          }else{
            return true
          }
        })
        if(!canSave) return
        let data = this.options.map(item=>{
          return {
            id:item.id,
            title : item.title,
            remark : item.content,
            userWriteTitle : item.userTitle,
            required : item.userCheck?1:0

          }
        })
        this.isSave = true
        let url = this.urlobj.saveParkingOption;
        this.$post(url, data).then(res => {
          this.isSave = false
          this.isEditable = false
          if(res.isSucceed){
            this.$Message.success('保存成功')
            this.getParkingOptionList()
          }
        }).catch(e=>{
          this.isEditable = false
          this.isSave = false
        })


      },
      getParkingOptionList(){
        let url = this.urlobj.getParkingOptionList;
        this.$post(url, {}).then(res => {
          if(res.rows.length){
            let data = res.rows.map((item,index)=>{
              return{
                index:index,
                id:item.id,
                title : item.title,
                content : item.remark,
                userTitle : item.userWriteTitle,
                userCheck : item.required?true:false,
                contentShow:item.remark?true:false,
                userShow:item.userWriteTitle?true:false,
              }

            })
            this.options = data

          }else{
            //如果没有选项新增一个空白选项
            this.options.push({
              index:0,
              id:-1,
              title:'',
              content:'',
              contentShow:false,
              userShow:false,
              userCheck:false,
              userTitle:'',
            })
            this.isEditable=true;
          }

        }).catch(e=>{

        })
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.$nextTick(() => {
        this.height = this.$refs.contentbox.offsetHeight - 60;
      });
      this.getParkingOptionList()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>
<style lang='less' scoped>
  //@import url(); 引入公共css类
  .wrapper {
    color: #666666;
    overflow: hidden;
    height: 100%;
  }

  .wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    /* height: 4px; */
  }
  .header-wrapper {
    display: flex;
    justify-content: center;
    height: 84px;
    line-height: 84px;
    position: relative;
  }
  .header {
    font-size: 25px;
    text-align: center;
  }
  .addManager {
    position: absolute;
    right: 20px;
    .btn-dc {
      background-color: #ff7c43;
      border-color: #ff7c43;
    }
  }
  /* 返回 */
  .left {
    position: absolute;
    left: 20px;
    font-size: 22px;
  }
  .content {
    //   @content();
    margin: 20px;
    margin-top: 0px;
    overflow: hidden;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    border: 1px solid #ddd;
    background-color: #fff;
  }
  .contenttitle{
    padding: 0 20px;
    border-bottom: 1px solid #ddd;
    height: 57px;
    line-height: 57px;
    font-size: 16px;
    color:#333;
  }
  .contentbox{
    padding: 20px;
    overflow-y: scroll;
  }
  .contentbox::-webkit-scrollbar {display:none}
  .contentop{
    color:#333;
    font-size: 16px;
    margin-right: 20px;
  }
  .option_item{
    border: 1px solid #ddd;
    margin-bottom: 20px;
    padding: 20px;
    color:#333;
  }
  .option_item>div:nth-child(n+2){
    margin-top: 20px;
  }
  .option_item>div:nth-child(n+3){
    color: #666;
  }

  .option_item_edit{
    margin-bottom: 20px;
    color:#333;
  }
  /*可编辑的*/
  .option_item_edit div:first-child{
    font-size: 14px;
    margin-top: 2px;
  }
  .option_item_edit > div{
    margin-bottom: 20px;
    align-items: center
  }
  //编辑框部分
  .input-wrapper {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding:10px;
    font-size: 16px;
  }
  .edit1{
    width: 515px;
    height: 90px;
  }
  .edit2{
    width: 835px;
    height: 185px;
  }
  .edit-title {
    width: 100%;
    border: none;
    resize: none;
    outline: none;
    font-size: 18px;
    color: #666;
  }
  .title-number {
    text-align: right;
    font-size: 14px;
    height: 14px;
    line-height: 14px;
    color: #999;
  }
  .delete{
    color:#d22b2b;
    margin-left: 30px;
  }
  .add2{
    border:1px dashed #dddddd;
    color:#a1a1a1;
    border-radius: 4px;
    font-size: 14px;
    width: 95px;
    justify-content: space-evenly;
    height: 28px;
    align-items: center;
    margin-bottom: 10px !important;
  }
  .add{
    border:1px solid #ff7c43;
    color:#ff7c43;
    margin-top: 30px;
  }

</style>
